import { render, staticRenderFns } from "./MainYoutube.vue?vue&type=template&id=0f6144ca&"
import script from "./MainYoutube.vue?vue&type=script&lang=js&"
export * from "./MainYoutube.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports